"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line no-shadow
var HttpStatusCode;
(function (HttpStatusCode) {
    /**
     * The request is larger than the server is willing or able to process. Previously called "Request Entity Too Large".
     */
    HttpStatusCode[HttpStatusCode["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
})(HttpStatusCode || (HttpStatusCode = {}));
exports.default = HttpStatusCode;
